// removed by extract-text-webpack-plugin
module.exports = {"page":"_2NgE9TGp6tAVysykpNanS1","periodLine":"_2CvI1bcD9j09fI5c3e7aGF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/Statistics.scss
// module id = 1384
// module chunks = 1